module.exports = __webpack_public_path__ + "img/1x2_ad.1b637f52.png";